export const GET_PRODUCT_STATISTICS = "GET_PRODUCT_STATISTICS";
